import classNames from "classnames";
import PropTypes from "prop-types";
import { compose, withProps, withState } from "recompose";

import { Form } from "@dpdgroupuk/mydpd-ui";

import styles from "./FileInput.module.scss";
import { Col, Row } from "react-bootstrap";
import { SELECT_FILE } from "../../constants/strings";

const FileInput = ({
  filename,
  input,
  label,
  meta,
  onFileChange,
  required,
  accept,
}) => (
  <Row className="align-items-baseline">
    <Col sm={10}>
      <input
        accept={accept}
        type="file"
        id="upload"
        className={classNames(styles.fileInput)}
        onChange={onFileChange}
      />
      <Form.MaterialTextInput
        input={{
          ...input,
          value: filename,
          onChange: () => {}, // NOTE: Prevent changes to the file input
          onBlur: () => {}, // NOTE: Prevent blur from affecting the file input
        }}
        label={label}
        meta={meta}
        name={"filename"}
        helperText={true}
        required={required}
        readOnly={true}
        autocomplete="off"
      />
    </Col>
    <Col sm={2}>
      <label className={styles.fileInputButton} htmlFor="upload">
        {SELECT_FILE}
      </label>
    </Col>
  </Row>
);

FileInput.defaultProps = {
  multiline: false,
  required: false,
};

FileInput.propTypes = {
  label: PropTypes.string,
  accept: PropTypes.any,
  filename: PropTypes.string,
  multiline: PropTypes.bool,
  required: PropTypes.bool,
  meta: PropTypes.object,
  input: PropTypes.object,
  onFileChange: PropTypes.func,
  setFilename: PropTypes.func,
};

export default compose(
  withState("filename", "setFilename", ""),
  withProps(({ setFilename, filename, input, onChange }) => ({
    onFileChange: async e => {
      const targetFile = e.target.files[0];
      if (targetFile) {
        input.onChange(targetFile);
        setFilename(targetFile.name);
        // Trigger blur after onChange to activate asyncValidate
        setTimeout(() => input.onBlur(targetFile), 0);
      } else if (!targetFile && filename.length === 0) {
        input.onChange(null);
        setFilename("");
        setTimeout(() => input.onBlur(null), 0);
      }
      onChange && onChange(e);
    },
  }))
)(FileInput);
